export default {
    LEI8629 : 'Lei 8.629/1993',
    LEI8666 : 'Lei 8.666/1993',
    LEI10520 : 'Lei 10.520/2002',
    LEI10847 : 'Lei 10.847/2004',
    LEI11652 : 'Lei 11.652/2008',
    LEI11947 : 'Lei 11.947/2009',
    LEI12462 : 'Lei 12.462/2011',
    LEI12512 : 'Lei 12.512/2011',
    LEI12663 : 'Lei 12.663/2012',
    LEI12865 : 'Lei 12.865/2013',
    LEI12873 : 'Lei 12.873/2013',
    LEI13303 : 'Lei 13.303/2016',
    LEI14133 : 'Lei 14.133/2021'
}
